import { oteApi } from 'yxt-biz-pc/packages/api';

/**
 * get 默认试题库详情
 */
export const getDefaultLib = (libId) => {
  return oteApi.get('/lib/default_lib');
};

/**
 * 快速建题
 * @param {object} bodyObj 请求体
 */
export const createQuesQuick = (bodyObj) => {
  return oteApi.post('/ques/batch/quick/full', bodyObj);
};

/**
 * 获取试题库分类列表
 * @param {object} bodyObj 请求参数
 */
export const getCatalogList = q => {
  return oteApi.get('/lib/catalog/list', q);
};

// 根据权限获取题库考核点树状表
export const getLibAndPoints = (bodyObj) => {
  return oteApi.get('/lib/lib/point/tree', bodyObj);
};

/**
 * 获取试题库详情
 * @param {string} libId 试题库ID
 */
export const getQuesLibDetail = (libId) => {
  return oteApi.get(`/lib/${libId}`);
};

/*
 * 获取试题列表（选择题库）【管理权限】
 * @param {object} bodyObj 请求参数
 */
export const getQuesLibList4select = (bodyObj) => {
  return oteApi.get('/lib/list/select/manager', bodyObj);
};

/**
 * 获取试题库下的考核点
 * @param {string} libId 试题库ID
 */
export const getPointList = (libId) => {
  return oteApi.get(`/lib/point/${libId}`);
};

/**
 * 获取试题库下的考核点，控制导航权限
 * @param {string} libId 试题库ID
 */
export const getPointListFunc = (libId) => {
  return oteApi.get(`/lib/func/point/${libId}`);
};

/**
 * 获取机构的难度级别
 * @returns "fiveLevel": true 是否为五级难度
 */
export const getQuesLevel = () => {
  return oteApi.get(`/config${(!window.localStorage.token || window.localStorage.isVisitor) ? '/stu' : ''}/quesLevel?orgId=${window.localStorage.orgId}`);
};
